exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-tip-content{padding:35px;margin:0;margin-block:auto;width:600px;background-color:#34596c;font-weight:600;text-align:center;border-radius:8px}@media(max-width:992px){.no-tip-content{width:100%}}", ""]);

// exports
